import moment from 'moment';
import { ConfigService } from '../services/config.service';

export function dateComparator(date1, date2) {
  let date1Number = moment(date1, ConfigService.dates.shortDateTimeFormat)
    .toDate()
    .getTime();
  let date2Number = moment(date2, ConfigService.dates.shortDateTimeFormat)
    .toDate()
    .getTime();

  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }

  return date1Number - date2Number;
}
